import React from 'react';

import AdminLayout from 'Pages/Admin/AdminLayout';

import Table from 'Components/HumanResources/Timesheets/Table';

export default class Absences extends React.Component {
    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        return (
            <AdminLayout>
                <Table
                    type='sick'
                    title={window.base.hr_timesheet_types['sick']?.label}
                    admin={true}
                    userId={this.props.match?.params?.user ?? null}
                />
            </AdminLayout>
        );
    }
}
